"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfProfileWithAddresses = instanceOfProfileWithAddresses;
exports.ProfileWithAddressesFromJSON = ProfileWithAddressesFromJSON;
exports.ProfileWithAddressesFromJSONTyped = ProfileWithAddressesFromJSONTyped;
exports.ProfileWithAddressesToJSON = ProfileWithAddressesToJSON;
exports.ProfileWithAddressesToJSONTyped = ProfileWithAddressesToJSONTyped;
const AddressDto_1 = require("./AddressDto");
/**
 * Check if a given object implements the ProfileWithAddresses interface.
 */
function instanceOfProfileWithAddresses(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('firstName' in value) || value['firstName'] === undefined)
        return false;
    if (!('lastName' in value) || value['lastName'] === undefined)
        return false;
    if (!('addresses' in value) || value['addresses'] === undefined)
        return false;
    if (!('specialties' in value) || value['specialties'] === undefined)
        return false;
    return true;
}
function ProfileWithAddressesFromJSON(json) {
    return ProfileWithAddressesFromJSONTyped(json, false);
}
function ProfileWithAddressesFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'addresses': (json['addresses'].map(AddressDto_1.AddressDtoFromJSON)),
        'specialties': json['specialties'],
    };
}
function ProfileWithAddressesToJSON(json) {
    return ProfileWithAddressesToJSONTyped(json, false);
}
function ProfileWithAddressesToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'addresses': (value['addresses'].map(AddressDto_1.AddressDtoToJSON)),
        'specialties': value['specialties'],
    };
}
//# sourceMappingURL=ProfileWithAddresses.js.map